// modules/init-compare-plans.js

/**
 * Gestione dello Slider "Confronta i Piani" e del toggle Personale/Famiglia.
 * 
 * - Inizializza Swiper su mobile/tablet per ogni gruppo di piani.
 * - Gestisce lo switch (radio/toggle) per mostrare/nascondere i gruppi.
 */

export function initComparePlans() {
    const section = document.querySelector('.compare-plans');
    if (!section) return;

    const switchBtn = section.querySelector('input[role="switch"]');
    const radioButtons = section.querySelectorAll('input[name="plan-type"]');
    const groups = section.querySelectorAll('.compare-plans__group');
    const swiperContainers = section.querySelectorAll('.compare-plans__swiper');

    let swiperInstances = {};

    // 1. Inizializzazione Swiper (Mobile/Tablet < 992px)
    const initSwipers = () => {
        const isMobile = window.innerWidth < 992;

        swiperContainers.forEach(container => {
            const groupType = container.dataset.group;

            if (isMobile) {
                if (!swiperInstances[groupType]) {
                    swiperInstances[groupType] = new Swiper(container, {
                        slidesPerView: 1,
                        spaceBetween: 16,
                        loop: false,
                        // autoplay: {
                        //     delay: 3000,
                        //     disableOnInteraction: false,
                        //     pauseOnMouseEnter: true,
                        // },
                        pagination: {
                            el: container.querySelector('.swiper-pagination'),
                            clickable: true,
                        },
                        breakpoints: {
                            // Su tablet un po' più grandi (es. 768px) mostriamo 2 slide
                            768: {
                                slidesPerView: 1.3,
                                spaceBetween: 25
                            }
                        }
                    });
                }
            } else {
                if (swiperInstances[groupType]) {
                    swiperInstances[groupType].destroy(true, true);
                    delete swiperInstances[groupType];
                }
            }
        });
    };

    // 2. Gestione Toggle Personale / Famiglia
    const updateGroups = (type) => {
        groups.forEach(group => {
            const isActive = group.dataset.group === type;
            group.classList.toggle('is-active', isActive);
            group.setAttribute('aria-hidden', !isActive);

            // Aggiorniamo Swiper se attivo (per ricalcolare dimensioni)
            if (isActive && swiperInstances[type]) {
                swiperInstances[type].update();
            }
        });
    };

    // Evento Switch (Checkbox)
    if (switchBtn) {
        switchBtn.addEventListener('change', () => {
            const type = switchBtn.checked ? 'famiglia' : 'personale';
            updateGroups(type);

            // Sincronizziamo anche i radio hidden per accessibilità/consistenza
            radioButtons.forEach(radio => {
                radio.checked = (radio.value === type);
            });
        });
    }

    // Avvio e Resize
    initSwipers();
    window.addEventListener('resize', initSwipers);
}
